import axios from 'axios'
const baseURL = 'https://app.creatyea.com'
// const baseURL = 'http://localhost:4000'
const instance = axios.create({
  baseURL,
  withCredentials: true,
  timeout: 60 * 1000,
  timeoutErrorMessage: 'Request Timeout, Please try again later.',
})

/**
 * 判断 JWT 是否已经过期。
 * @param {string|null} token 登录 token
 * @returns {boolean} 是否过期或无效
 */
export const isTokenExpired = (token) => {
  if (!token) {
    return true
  }

  try {
    const payload = JSON.parse(window.atob(token.split('.')[1]))
    return Boolean(payload?.exp && payload.exp * 1000 <= Date.now())
  } catch (error) {
    return true
  }
}

/**
 * 清理本地登录状态并跳转登录页。
 */
const redirectToLogin = () => {
  localStorage.removeItem('token')
  localStorage.removeItem('id')

  if (window.location.pathname !== '/login') {
    window.location.href = '/login'
  }
}

/**
 * 请求发送前补充本地保存的登录 token。
 * @param {import('axios').InternalAxiosRequestConfig} config 请求配置
 * @returns {import('axios').InternalAxiosRequestConfig} 带鉴权头的请求配置
 */
instance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')

  if (isTokenExpired(token)) {
    redirectToLogin()
    return config
  }

  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
})

/**
 * 响应 401 时清理本地登录状态。
 * @param {any} response 接口响应
 * @returns {any} 原始响应
 */
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      redirectToLogin()
    }

    return Promise.reject(error)
  },
)

export default instance
